import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { truncateText, HERO_MAX_KICKER_LENGTH } from 'helpers/ContentHelper';

import style from './Kicker.module.scss';

const Kicker = ({ alternativeHeadline, theme = {} }) => {
  if (!alternativeHeadline) return null;
  const text = truncateText(alternativeHeadline, HERO_MAX_KICKER_LENGTH);
  return <div className={classNames([style.kicker, theme.kicker])}>{text}</div>;
};

export default Kicker;

Kicker.propTypes = {
  alternativeHeadline: PropTypes.string,
  theme: PropTypes.shape({}),
};
